import { render } from "./qzf-video.vue?vue&type=template&id=6ea566a8&scoped=true"
import script from "./qzf-video.vue?vue&type=script&lang=js"
export * from "./qzf-video.vue?vue&type=script&lang=js"

import "./qzf-video.vue?vue&type=style&index=0&id=6ea566a8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea566a8"]])

export default __exports__